import './style.scss'

import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import utility from 'src/utils/utility'

import InstitutionList from './InstitutionList'
import CreateInstitution from './CreateInstitution'

const InstitutionCreationPage = () => {
    const location = useLocation()

    const [showCreate, setShowCreate] = useState(
        !!(location.state as any)?.startInCreateMode
    )

    return (
        <>
            {showCreate ? (
                <CreateInstitution
                    onBack={() => setShowCreate(false)}
                />
            ) : (
                <InstitutionList
                    onCreate={() => setShowCreate(true)}
                />
            )}
        </>
    )
}

export default utility.routeData(
    'institution-creation',
    'Institution Creation',
    <InstitutionCreationPage />,
)